import { Spinner } from "flowbite-react";

export function SpinnerC() {
  return <Spinner color={"success"} size={"xl"} aria-label="Center-aligned spinner example" />;
}
